import * as editorErrTypes from 'config/editErrorTypes';

export const IG_WEBHOOK_SUBSCRIBE_API_RESPONSE = {
    [editorErrTypes.VERIFY_HASHTAGS_IS_NOT_EXIST]: (payload = {}) =>
        payload?.message === 'please verify hashTags exist' && payload?.code === 'PMS-C0-F0',
    [editorErrTypes.VERIFY_PRIVATE_REPLY_KEYWORD_IS_NOT_EXIST]: (payload = {}) =>
        payload?.message === 'please verify private reply keyword exist' &&
        payload?.code === 'PMS-C0-F0',
    [editorErrTypes.VERIFY_HASHTAGS_NOT_EMPTY]: (payload = {}) =>
        payload?.message === 'please verify hashTags not empty' && payload?.code === 'PSP-V0-F0',
    [editorErrTypes.VERIFY_KEYWORD_NOT_EMPTY]: (payload = {}) =>
        payload?.message === 'please verify private reply keyword not empty' &&
        payload?.code === 'PMS-V0-F0',
    [editorErrTypes.DUPLICATE_HASHTAGS]: (payload = {}) =>
        payload?.message === 'hash tags duplicate with current online promotion' &&
        payload?.code === 'PMS-C0-F0',
    [editorErrTypes.DUPLICATE_KEYWORD]: (payload = {}) =>
        payload?.message === 'private reply keyword duplicate with current online promotion' &&
        payload?.code === 'PMS-C0-F0',
    [editorErrTypes.INSTAGRAM_ID_NOT_FOUND]: (payload = {}) =>
        payload?.message === 'sponsor instagram business account id not found' &&
        payload?.code === 'CUDF-R1-F0',
    [editorErrTypes.CAMPAIGN_ID_IS_INCORRECT]: (payload = {}) =>
        payload?.message === 'please verify campaign id is correct' && payload?.code === 'SP-R1-F0'
};
